module.exports = __webpack_public_path__ + "static/img/1000000466_red.8df97391.jpg";